import moment from "moment";
import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getSlots } from "../../../redux/coaching/actions";
import { SessionKeys } from "../../../utils/AppUtils";
import _ from "lodash";
import ShimmerScreen from "../../../components/Layouts/ShimmerScreen";
import FormButtonComponent from "../../../components/NewDesign/FormControl/FormButton/FormButtonComponent";
import { RightArrowIcon } from "../../../utils/SvgComps";
import  "../SuggestedCoaches/CoacheDetail.scss"; 
// import dayjs from "dayjs";
const RescheduleSlotModal = (props) => {
  
  const { t } = useTranslation();

  const { currencyCode, sellingPrice,show,setShow, coachId, productId } = props;
  
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const navigate = useNavigate();
  
    const dispatch = useDispatch();
  
    const sessionDetails = useSelector((state) => state.coaching.getSlotsData);
    const userDetailRes = useSelector((state) => state.user.userBroker);
  
    const [filteredSlotsData, setFilteredSlotsData] = useState([]);
    const [allSlotsData, setAllSlotsData] = useState([]);
  
    const [error, setError] = useState("");
    const [slotsApiCalled, setSlotsApiCalled] = useState(false);
  
    const [activeSlot, setActiveSlot] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
  
    const [selectedDate, setSelectedDate] = useState(
      moment().format("MMMM YYYY")
    );
    const [date, setDate] = useState(moment());
  
    const [currentMonth2, setCurrentMonth2] = useState(
      moment().format("MMMM YYYY")
    );
  
    const [loader, setLoader] = useState(false);
    const [selectedHours, setSelectedHours] = useState("");
    const [checkoutLoader, setCheckoutLoader] = useState(false);
    useEffect(() => {
      setLoader(false);
      console.log("selected slot---", activeSlot);
      let totalHours = 0;
  
      activeSlot.forEach((slot) => {
        const startTime = parseInt(slot.start_time);
        const endTime = parseInt(slot.end_time);
  
        const timeDiff = endTime - startTime;
        const hoursDiff = timeDiff / 3600; // convert seconds to hours
  
        totalHours += hoursDiff;
      });
      console.log("selected slot---hours", totalHours);
      setSelectedHours(totalHours);
    }, [activeSlot]);
  
    useEffect(() => {
      getSessionData();
    }, [coachId]);
  
    useEffect(() => {
      console.log("sessionDetails", sessionDetails);
      console.log("slotsApiCalled", slotsApiCalled);
      if (!_.isEmpty(sessionDetails) && slotsApiCalled) {
        if (sessionDetails?.status === "success") {
          const slots = sessionDetails?.payload?.payload;
          // Extract slot data
          console.log("slots1", slots);
          console.log("current month first time", selectedDate, date);
  
          if (Array.isArray(slots)) {
            let sortedSlots = slots.sort(
              (a, b) => new Date(a.date) - new Date(b.date)
            );
            setAllSlotsData(sortedSlots);
            const selectedMonthData = sortedSlots.filter((data) => {
              const date = moment(data.date);
              const month = date.format("MMMM YYYY");
              return month === moment().format("MMMM YYYY");
            });
            setFilteredSlotsData(selectedMonthData);
          } else {
            console.error("Slots data is not an array:", slots);
            setFilteredSlotsData([]);
          }
        } else {
          console.error("Failed to fetch slots.");
          setFilteredSlotsData([]);
          setIsFetching(false);
        }
        setIsFetching(false);
        setSlotsApiCalled(false);
      }
    }, [sessionDetails]);
  
    const getSessionData = () => {
      setSlotsApiCalled(true);
      setIsFetching(true);
      dispatch(
        getSlots({
          module: "getSlotsModule",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            coach_id: coachId,
          },
        })
      );
    };
  
    useEffect(() => {
      const selectedMonthData = allSlotsData.filter((data) => {
        const date = moment(data.date);
        const month = date.format("MMMM YYYY");
        return month === selectedDate;
      });
      console.log(
        "selected month data----",
        filteredSlotsData,
        selectedMonthData,
        selectedDate
      );
      setFilteredSlotsData(selectedMonthData);
    }, [selectedDate]);
  
    const handlePreviousMonth = () => {
      setDate(date.clone().subtract(1, "month"));
      setSelectedDate(date.clone().subtract(1, "month").format("MMMM YYYY"));
    };
  
    const handleNextMonth = () => {
      setDate(date.clone().add(1, "month"));
      setSelectedDate(date.clone().add(1, "month").format("MMMM YYYY"));
    };
  
    // const handleError = () => {
    //   // Set the error message
    //   setError(t("pleaseSelectValidSessionBeforeBooking"));
  
    //   // Clear the error message after 5 seconds
    //   setTimeout(() => {
    //     setError("");
    //   }, 5000);
    // };
  
    const getSlotClass = (dayData, slot) => {
      return activeSlot.some((item) => item.id === slot.id) ? "active-page" : "";
    };
  
    const redirectTo = () => {
      
    };

  return (
    <>
      <Modal
        //fullscreen={true}
        show={show}
        size="lg"
        onHide={() => setShow(false)}
        className="custom-modal"
        centered
      >
        <Modal.Header closeButton className="p-4">
          <Modal.Title className="mentor-title mb-0">
            {t("bookYourSessionFromAvailableSlots")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4"> 
        
        <div className="coach-detail-sec p-0 container-slot w-100">
        <div className="pt-4 pb-4 d-flex justify-content-between">
          <div className="mentor-title mb-0">
          </div>
          <div className="d-flex cal_iconLR cal-btn-black">
            <button
              className="button-reset cursor-pointer"
              onClick={() => handlePreviousMonth()}
            >
              <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="14" cy="14" r="13.5" stroke="#415385" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.1918 18.3752C14.9625 18.3752 14.7342 18.286 14.5627 18.1083L11.1825 14.6083C10.8518 14.2645 10.8562 13.7193 11.1939 13.3816L14.6939 9.88159C15.0352 9.53947 15.589 9.53947 15.9312 9.88159C16.2724 10.2237 16.2724 10.7767 15.9312 11.1188L13.0393 14.0107L15.8209 16.8921C16.1569 17.2403 16.1473 17.7942 15.7999 18.1293C15.6293 18.2938 15.4105 18.3752 15.1918 18.3752Z"
                  fill="#415385"
                />
              </svg>
            </button>
            <p className="calen">{selectedDate}</p>
            <button
              className="button-reset cursor-pointer"
              onClick={() => handleNextMonth()}
            >
              <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="14"
                  cy="14"
                  r="13.5"
                  transform="rotate(180 14 14)"
                  stroke="#415385"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.8082 9.62478C13.0375 9.62478 13.2658 9.71403 13.4373 9.89166L16.8175 13.3917C17.1482 13.7355 17.1438 14.2807 16.8061 14.6184L13.3061 18.1184C12.9648 18.4605 12.411 18.4605 12.0688 18.1184C11.7276 17.7763 11.7276 17.2233 12.0688 16.8812L14.9607 13.9893L12.1791 11.1079C11.8431 10.7597 11.8527 10.2058 12.2001 9.87066C12.3707 9.70616 12.5895 9.62478 12.8082 9.62478Z"
                  fill="#415385"
                />
              </svg>
            </button>
          </div>
        </div>
        <div className="slotparent">
          <div className="wrapper-calds">
            <div className="containertabs">
              {isFetching ? (
                <>
                  <div className="listbox d-flex align-items-start">
                    <div className="dtebx date-header text-center d-flex gap-2 flex-column">
                      {[0, 1, 2, 3, 4].map((slot) => (
                        <>
                          <ShimmerScreen
                            case="rect"
                            height="2rem"
                            width="2rem"
                          />
                        </>
                      ))}
                    </div>
                    <div className="datslot-box">
                      {[0, 1, 2, 3, 4].map((slot) => (
                        <>
                          <ShimmerScreen
                            case="rect"
                            height="2.5rem"
                            width="100%"
                          />
                        </>
                      ))}
                    </div>
                  </div>
                </>
              ) : !_.isEmpty(filteredSlotsData) ? (
                <>
                  {filteredSlotsData.map((dayData, index) => {
                    return (
                      <div className="listbox d-flex" key={index}>
                        <div className="dtebx date-header text-center">
                          <strong>{moment
                            .unix(dayData.date_time)
                            .tz(
                              userDetailRes?.payload?.payload
                                ?.timezoneAbbr
                            )
                            .format("DD")}</strong>{" "}
                          <br />
                          {moment
                            .unix(dayData.date_time)
                            .tz(
                              userDetailRes?.payload?.payload
                                ?.timezoneAbbr
                            )
                            .format("MMM")}
                        </div>
                        <div className="datslot-box">
                          {Array.isArray(dayData.slot) &&
                          dayData.slot.length > 0
                            ? dayData.slot
                                .sort((slotA, slotB) => {
                                  const timeA = slotA.start_time;
                                  const timeB = slotB.start_time;
                                  return timeA - timeB;
                                })
                                .map((slot, slotIndex) => {
                                  const isPastSlot = moment
                                    .unix(slot.end_time)
                                    .isBefore(moment());
                                  return (
                                    <button
                                      disabled={slot.is_booking || slot.is_locked || isPastSlot}
                                      key={slotIndex}
                                      className={`time-slot-btn ${getSlotClass(
                                        dayData,
                                        slot
                                      )}`}
                                      onClick={() => {
                                        setLoader(true);
                                        if (slot.is_booking || isPastSlot) {
                                          return;
                                        }
                                        let isSlotPresent = activeSlot.some(
                                          (item) => item.id === slot.id
                                        );
                                        if (isSlotPresent) {
                                          let updatedSlots = activeSlot.filter(
                                            (item) => item.id !== slot.id
                                          );
                                          setActiveSlot(updatedSlots);
                                        } else {
                                          let slots = [];
                                          slots.push(slot);
                                          setActiveSlot(slots);
                                        }
                                      }}
                                    >
                                      {moment
                                        .unix(slot.start_time)
                                        .tz(
                                          userDetailRes?.payload?.payload
                                            ?.timezoneAbbr
                                        )
                                        .format("HH:mm")}{" "}
                                      -{" "}
                                      {moment
                                        .unix(slot.end_time)
                                        .tz(
                                          userDetailRes?.payload?.payload
                                            ?.timezoneAbbr
                                        )
                                        .format("HH:mm")}
                                    </button>
                                  );
                                })
                            : t("noSlotsAvailable")}
                        </div>
                      </div>
                    );
                  })}
                </>
              ) : (
                <section className="error-box">
                  <img src="/images/pana.svg" alt="error-svg" />
                  <div className="error-msgs">
                    {t(
                      "Currently, no session available for this coach. Please select another or month to get started!"
                    )}
                  </div>
                </section>
              )}
            </div>
          </div>
          {error && (
            <Form.Text className="text-danger d-flex justify-content-center ">
              {error}
            </Form.Text>
          )}
        </div>

        <div className="sep"></div>
        <div className="d-flex footer-btn-card justify-content-between align-items-center gap-1">
          <div className="price-sec-xl">
            {selectedHours > 0
              ? `${t(
                  "Total"
                )} (${selectedHours} Hrs)`
              : ""}
          </div>
          <div className="d-flex gap-3">
            <Button variant="primary" onClick={() => setShow(false)}>
              {t("cancel")}
            </Button>

            <FormButtonComponent
              isPrimary={true}
              leftIcon={""}
              rightIcon={<RightArrowIcon />}
              isDisabled={_.isEmpty(activeSlot)}
              btnName={t("Add to Schedule")}
              btnAction={() => redirectTo()}
              showLoader={checkoutLoader}
            />
          </div>
        </div>
      </div>
       
      
          {/* Top-level Tabs */}
          
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-end gap-3 btn-footer p-4 border-0">
        
        </Modal.Footer>

      </Modal>
      
    </>
  )
}

export default RescheduleSlotModal